import { Component } from '@angular/core';

@Component({
  selector: 'app-no-properties',
  templateUrl: './no-properties.component.html',
  styleUrls: ['./no-properties.component.scss']
})
export class NoPropertiesComponent {
}
